import { ApiService } from './api.services';
import { BaseService } from 'app/core/base.service';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { HistPlanoParticipante } from '../models/histPlanoParticipante.model';

export class HistPlanoParticipanteService extends ApiService implements BaseService<HistPlanoParticipante>{

    private strAction = 'api/HistPlanoParticipanteADO';

    constructor(
        httpClient: HttpClient,
        private route: Router) {
        super(httpClient, route);
    }

    getAll(): Observable<HistPlanoParticipante[]> {
        return this.get<HistPlanoParticipante[]>(this.strAction + `/GetAll`);
    }

    deleteById(idPessoa: number) {
        return this.post(this.strAction + `/DeleteById?id=${idPessoa}`);
    }

    getById(idPessoa: number): Observable<HistPlanoParticipante> {
        return this.get(this.strAction + `/GetById?id=${idPessoa}`);
    }

    Post(histPlanoParticipante: HistPlanoParticipante): Observable<HistPlanoParticipante> {
        return this.post<HistPlanoParticipante>(this.strAction + `/PostInserePlanoParticipante`, histPlanoParticipante);
    }

}